import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { chatBotPath } from "@/react/helpers/urlHelpers";
import { SuggestedQuestionButton } from "@circle-react/components/SettingsApp/CommunityInbox/BotChatRoom/Shared/SuggestedQuestionButton";
import { useCreateBotChat } from "@circle-react/components/SettingsApp/CommunityInbox/hooks/useCreateBotChat";
import { textToRichText } from "@circle-react/helpers/richTextHelpers";
import type { Profile } from "@circle-react/types/CommunityBot/Profile";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useCommunityAiAgentProfileContext } from "../context";

export const Body = () => {
  const { agent } = useCommunityAiAgentProfileContext();
  const { can_interact: canInteract } = agent;
  const history = useHistory();

  const { createChat } = useCreateBotChat();
  const askAgent = (profile: Profile, question: string) => {
    void createChat({
      id: profile.id,
      body: textToRichText(question),
    })
      .then((chat: Chat) => {
        history.push(chatBotPath({ id: chat.id.toString() }));
      })
      .catch(e => {
        console.error(e);
      });
  };

  return (
    <div className="bg-primary flex h-[50vh] min-h-[640px] flex-col overflow-auto p-8">
      <div className="flex flex-col items-start gap-6">
        <div className="flex flex-col gap-3">
          <Typography.LabelSm weight="semibold">
            {t("community_bot.profiles.bio_label")}
          </Typography.LabelSm>
          <Typography.BodySm>{agent.bio}</Typography.BodySm>
        </div>
        <div className="flex flex-col gap-3">
          {canInteract &&
            agent.suggested_questions &&
            agent.suggested_questions.length > 0 && (
              <>
                <Typography.LabelSm weight="semibold">
                  {t("community_bot.profiles.suggested_questions_label")}
                </Typography.LabelSm>
                <div className="flex flex-wrap gap-2">
                  {agent.suggested_questions.map((question: string) => (
                    <SuggestedQuestionButton
                      key={question}
                      question={question}
                      onClick={() => askAgent(agent.profile, question)}
                    />
                  ))}
                </div>
              </>
            )}
        </div>
      </div>
    </div>
  );
};
